<template>
  <a-spin
    :spinning="isLoading"
    class="custom-spinner"
    style="height: 100vh; top: 20%"
  >
    <administrator-project-layout :model="model">
      <template #underInfo>
        <div class="administrator-project__common-progress" v-if="model.id">
          <progress-bar-generated
            :show-label="true"
            :completed="model.completedCount"
            :completed-overdue="model.completedOverdueCount"
            :incomplete-overdue="model.incompleteOverdueCount"
            :incomplete="model.incompleteCount"
          />
        </div>
      </template>
      <a-row class="project-management__team">
        <template v-if="!showExecutorProfile">
          <team-member-card
            v-for="(executor, index) in team"
            :key="index"
            :executor="executor"
            :is-my-project="model.isMyProject"
            @click="handleShowExecutorProfile(executor)"
            @change-leader="handleShowForm"
          />
        </template>
      </a-row>
      <team-member-profile
        v-if="showExecutorProfile"
        :executor="currentExecutor"
        :disabled="true"
        :is-project-external="model.isExternal"
        @close="handleHideExecutorProfile"
      />
      <c-drawer v-model:open="isShowForm" destroyOnClose>
        <ProjectManagerChangeFrom
          @close="handleCloseForm"
          @update="updateLeader"
        />
      </c-drawer>
    </administrator-project-layout>
  </a-spin>
</template>

<script setup>
  import { onMounted, reactive, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import AdministratorProjectLayout from '../components/AdministratorProjectLayout.vue';
  import TeamMemberCard from '@/components/projects/team/TeamMember/TeamMemberCard.vue';
  import TeamMemberProfile from '@/components/projects/team/TeamMember/TeamMemberProfile.vue';
  import ProgressBarGenerated from '@/components/projects/portfolio/components/ProgressBarGenerated.vue';
  import ProjectManagerChangeFrom from '@/components/projects/team/ProjectManager/ProjectManagerChangeForm.vue';
  import CDrawer from '@/components/UI/CDrawer.vue';

  const api = useApi();
  const route = useRoute();
  const model = reactive({
    id: null,
    number: '',
    name: 'Новый проект',
    description: '',
    projectType: '',
    requestId: null,
    status: {
      type: 'draft',
      text: 'Черновик',
    },
    projectStatusId: null,
    isMyProject: false,
    completedCount: 0,
    completedOverdueCount: 0,
    incompleteOverdueCount: 0,
    incompleteCount: 0,
  });
  const showExecutorProfile = ref(false);
  const currentExecutor = ref(null);
  const team = ref([]);
  const isLoading = ref(true);
  const isShowForm = ref(false);

  onMounted(async () => {
    await getModel();
    await getTeam();
    isLoading.value = false;
  });

  const getModel = async () => {
    try {
      const response = await api.administratorPage.getProject(route.params.id);
      model.name = response.project.name;
      model.number = response.project.id;
      model.id = response.project.id;
      model.type = response.project.type;
      model.requestId = response.project.requestId;
      model.status = response.project.status;
      model.projectStatusId = response.project.projectStatusId;
      model.isMyProject = response.project.isMyProject;
      model.completedCount = response.project.completedCount;
      model.completedOverdueCount = response.project.completedOverdueCount;
      model.incompleteOverdueCount = response.project.incompleteOverdueCount;
      model.incompleteCount = response.project.incompleteCount;
    } catch (error) {
      console.error('error', error);
    }
  };

  const getTeam = async () => {
    try {
      const response = await api.projectExecutor.stats(
        new URLSearchParams({
          projectId: route.params.id,
          sort: '-isLeader,lastName,firstName,middleName',
        })
      );
      team.value = response.executors.items;
    } catch (error) {
      console.error('error', error);
    }
  };

  const handleShowExecutorProfile = (executor) => {
    currentExecutor.value = executor;
    showExecutorProfile.value = true;
  };

  const handleHideExecutorProfile = () => {
    currentExecutor.value = null;
    showExecutorProfile.value = false;
  };

  const handleShowForm = () => {
    isShowForm.value = true;
  };

  const handleCloseForm = () => {
    isShowForm.value = false;
  };

  const updateLeader = async () => {
    isLoading.value = true;
    team.value = [];
    await getTeam();
    isLoading.value = false;
  };
</script>

<style lang="scss" scoped>
  .administrator-project__common-progress {
    margin-top: 42px;
  }

  .project-management__team {
    column-gap: 20px;
    row-gap: 20px;
  }
</style>
